<template lang="pug">
  v-container
    v-btn(@click="getEventOrders") Orders By Events
    v-badge(right)
      span(slot="badge" overlap) {{count}}
      v-btn(@click="getOrders") Get Orders 

    v-expansion-panel
      v-expansion-panel-content(v-for="(k, i) in eventKeys" :key="i")
        div(slot="header")
          span {{getEventName(k)}}
        v-card
          v-card-text 
            v-expansion-panel
              v-expansion-panel-content(v-for="(o, i) in eventOrders[k]" :key="i")
                div(slot="header")
                  v-layout(row)
                    v-flex(xs8) {{o.name}}
                    v-flex(xs4) ${{totalCost(o)}}
                v-card(color="blue-grey lighten-5")
                  v-card-title.title 
                    v-flex(xs6) Order Details
                    
                  v-card-text() 
                    v-layout.my-2(row wrap)
                      v-flex 
                        strong Order Date: 
                        span {{new Date(o.orderDate).toDateString()}}
                      v-flex
                        strong Pickup Time:
                        time-changer(:time="o.collectionTime") 
                      v-flex
                        strong Email: 
                        span {{o.email}}
                      v-flex
                        strong Phone:
                        span {{o.phone}}
                    v-layout.subheading(row)
                      v-flex(xs5) Item
                      v-flex(xs1) Amt
                      v-flex.text-xs-right(xs3) @
                      v-flex.text-xs-right(xs3) Cost
                    v-layout(row wrap v-for="i in o.items" v-if="o.items")
                      v-flex.my-1(xs12)
                        v-layout(row)
                          v-flex(xs5) {{i.itemName}}
                          v-flex(xs1) {{i.amount}}
                          v-flex.text-xs-right(xs3) ${{i.cost}}
                          v-flex.text-xs-right(xs3) ${{i.cost * i.amount}}
                      v-flex(xs12)
                        v-divider
                    v-layout(row wrap v-for="i in o.packages" v-if="o.packages")
                      v-flex.my-1(xs12)
                        v-layout(row)
                          v-flex(xs5) {{i.packageName}}
                          v-flex(xs1) {{i.amount}}
                          v-flex.text-xs-right(xs3) ${{i.cost}}
                          v-flex.text-xs-right(xs3) ${{i.cost * i.amount}}
                      v-flex(xs12)
                        v-divider
                  v-card-actions.text-xs-right
                    v-flex.title.pa-2 Total: ${{totalCost(o)}}TT
          
          
</template>
<script>
import Order from "../../components/Order"
import TimeChanger from '../../components/TimeChanger.vue';
export default {
  name:"Orders",
  data:()=>({
    selectedOrder:{},
    eventOrders:null,
    eventKeys:[]
  }),
  components:{Order, TimeChanger},
  created(){
    this.$store.dispatch("getOrders")
  },
  computed: {
    orders(){
      return this.$store.state.orders
    },
    count(){
      return this.$store.state.orders.length
    }
  },
  methods:{
    openOrder(o){
      console.log("clicked")
      this.selectedOrder = {...o}
    },
    async getEventOrders(){
      console.log('inside getEventOrders')
      let events= null

      events = this.orders.reduce((e,order)=>{
        e[order.selectedEvent] = e[order.selectedEvent] || []
        e[order.selectedEvent].push(order)
        return e
      }, {})
      this.eventKeys = Object.keys(events)
      this.eventOrders = events
    },
    totalCost(order){
      let total = 0
      if (order.packages){
        order.packages.forEach(p=>{
          total += p.cost * p.amount
        })
      }
      if(order.items){
        order.items.forEach(i=>{
          total += i.cost * i.amount
        })
      }
      return total
    },
    getEventName(eventId){
      let name = ''
      let e = null
      e = this.$store.state.events.find(ev=>{
        return ev.id === eventId
      })
      console.log(e)
      return e.eventName
    },
    getOrders(){
      this.$store.dispatch("getOrders")
    }

  }
}
</script>
